import { SponsorshipVoucherApi } from '@blank/api'
import { Image } from 'modules/common/components/Image/Image'
import { Link } from 'modules/common/components/Link/Link'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { Trans } from 'next-i18next'
import { SponsorshipRewards } from './SponsorshipRewards/SponsorshipRewards'
import { SponsorshipVoucherCode } from './SponsorshipVoucherCode/SponsorshipVoucherCode'

interface Props {
  sponsorshipVoucher: SponsorshipVoucherApi
}

export const SponsorshipOfferContainer = ({
  sponsorshipVoucher: {
    referrerReward,
    refereeReward,
    conditionsLink,
    voucherCode,
  },
}: Props) => {
  const { t } = useTranslation('settings-components')

  return (
    <div className="flex w-full items-start justify-between rounded-2xl bg-primary-90 py-12 text-center">
      <Image
        alt="card-extended-cropped"
        height="225"
        width="175"
        src="/assets/img/card-extended-cropped.png"
        className="mt-20"
      />
      <div className="flex flex-col items-center px-10">
        <SponsorshipRewards
          refereeReward={refereeReward}
          referrerReward={referrerReward}
        />
        <Trans parent="h2" className="mb-8">
          {t('sponsorshipOfferContainer.title')}
        </Trans>
        <SponsorshipVoucherCode
          voucherCode={voucherCode}
          refereeReward={refereeReward}
        />
        <Trans
          parent="p"
          components={{
            linkComponent: (
              <Link href={conditionsLink} className="font-bold underline" />
            ),
          }}
        >
          {t('sponsorshipOfferContainer.description')}
        </Trans>
      </div>

      <Image
        alt="card-basic-cropped"
        height="225"
        width="175"
        src="/assets/img/card-basic-cropped.png"
        className="mt-40"
      />
    </div>
  )
}
